import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const ssoGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  if (auth.user?.type === 'company' || auth.user?.type === 'domain_expert' || auth.isDigilabsUser()) {
    return true;
  }

  return router.createUrlTree(['/labs/ai-dev-console']);
};
